var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup2010(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.818,
    height: 90.818,
    viewBox: "0 0 90.818 90.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M173.079,304.959A45.409,45.409,0,1,1,127.67,259.55a45.409,45.409,0,0,1,45.409,45.409Z",
    transform: "translate(-82.261 -259.55)",
    fill: "#003975",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M156.01,301.639a31.658,31.658,0,1,1-31.657-31.657A31.658,31.658,0,0,1,156.01,301.639Z",
    transform: "translate(-78.77 -256.057)",
    fill: "#003975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M105.928,296.713l8.854,8.854,21.9-21.9a1.32,1.32,0,0,1,1.863,0l1.4,1.4a1.316,1.316,0,0,1,0,1.863L117.111,309.76l-1.4,1.4a1.317,1.317,0,0,1-1.425.289h0a1.311,1.311,0,0,1-.437-.287l-1.4-1.4-9.786-9.785a1.319,1.319,0,0,1,0-1.865l1.4-1.4a1.318,1.318,0,0,1,1.862,0Z",
    transform: "translate(-75.825 -251.948)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2010);
export default __webpack_public_path__ + "static/media/Group 2010.a9cf50c97280c0243d60bebaded0e40d.svg";
export { ForwardRef as ReactComponent };